export default {
  TIES_DEL_PER_ADDR_START: 'TIES_DEL_PER_ADDR_START',
  TIES_DEL_PER_ADDR_SUCCESS: 'TIES_DEL_PER_ADDR_SUCCESS',
  TIES_DEL_PER_ADDR_FAILURE: 'TIES_DEL_PER_ADDR_FAILURE',
}
